<template>
  <section class="edit">
    <div id="div5" ref="div5"></div>
    <div id="div6" :style="`height:${height}px`"></div>
  </section>
</template>
<script>
import Editor from "wangeditor";
import { onMounted, watch, reactive, toRefs } from "vue";
import { upload } from "@/api/common";
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  setup(props, context) {
    const state = reactive({
      editor: null,
      height: props.height || 400,
    });
    watch(
      () => props.content,
      (value) => {
        console.log(state.editor, value);
        // if (oldValue == value) return;
        //
      }
    );
    const initVal = (value) => {
      state.editor.txt.html(value);
    };
    onMounted(() => {
      if (state.editor != null) {
        return;
      }
      document.getElementById("div5").innerHTML = "";
      state.editor = new Editor("#div5", "#div6");

      state.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      state.editor.config.showLinkImg = false;
      state.editor.config.uploadImgServer = "/upload";
      state.editor.config.customUploadImg = function(files, insert) {
        files.forEach((file) => {
          let param = new FormData();
          param.append("file", file);
          upload(param).then((res) => {
            console.log(res, "url");
            insert(res.url);
          });
        });
      };
      state.editor.create();

      state.editor.config.onchange = (html) => {
        context.emit("change", html);
      };
      state.editor.txt.html(props.content);
    });

    return {
      ...toRefs(state),
      initVal
    };
  },
};
</script>
<style>
.edit {
  border: 1px solid #d9d9d9;
}
#div5 {
  border-bottom: 1px solid #d9d9d9;
}
#div6 {
  background: #f1f7f9;
}
</style>
